// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2hTuV","allowed":"styles_allowed__3eXuT","selected":"styles_selected__2EdAr"};